module.exports = __webpack_public_path__ + "img/7seasLogo.f1dc68da.png";